import React, { useEffect, useState, useMemo } from 'react';

import swal from 'sweetalert';

import CreateButton from '../../../elements/CreateButton';
import DeleteButton from '../../../elements/DeleteButton';
import EditButton from '../../../elements/EditButton';
import Loader from '../../../elements/Loader';
import TableDraggable from '../../../elements/TableDraggable';
import axios from '../../../services/MyAxios';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import {
    CASINO_GAME_CATEGORY_BLOCKS_CREATE,
    CASINO_GAME_CATEGORY_BLOCKS_DELETE,
    CASINO_GAME_CATEGORY_BLOCKS_EDIT,
} from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

function GameCategoryBlockList() {
    const [gameCategoryBlocks, setGameCategoryBlocks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const apiUrl = '/crea/casino/api/game-category-blocks';

    const getGameCategoryBlocks = () => {
        setIsLoading(true);
        axios.get(apiUrl).then((response) => {
            setGameCategoryBlocks(response.data);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        getGameCategoryBlocks();
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'casino_game_category_block_translations[0].name',
            },
            {
                Header: 'Category url',
                accessor: 'casino_game_category_block_translations[0].casino_game_category_translation.url',
                Cell: ({ value }) => (
                    <a href={value} target="_blank" rel="noreferrer">
                        {value}
                    </a>
                ),
            },
            {
                Header: 'Redirect url',
                accessor: 'casino_game_category_block_translations[0].redirect_url',
            },
            {
                Header: 'Image',
                accessor: 'image_path',
                Cell: ({ value }) => (
                    <img
                        className="dark-transparent-background p-1"
                        src={value}
                        style={{ maxWidth: '100px', height: 'auto' }}
                        alt="Category img"
                    />
                ),
            },
            {
                Header: 'Actions',
                accessor: 'id',
                Cell: ({ value }) => (
                    <div>
                        <EditButton
                            url={replaceUrlParams(CASINO_GAME_CATEGORY_BLOCKS_EDIT, { id: value })}
                            permissions={[CRM_PERMISSION.GAME_CATEGORY_BLOCKS_EDIT]}
                            key="edit"
                            action={getGameCategoryBlocks}
                        />
                        <DeleteButton
                            url={replaceUrlParams(CASINO_GAME_CATEGORY_BLOCKS_DELETE, { id: value })}
                            permissions={[CRM_PERMISSION.GAME_CATEGORY_BLOCKS_DELETE]}
                            key="delete"
                            action={getGameCategoryBlocks}
                        />
                    </div>
                ),
            },
        ],
        []
    );

    const onDropCallback = (order) => {
        const updateUrl = '/crea/casino/api/game-category-blocks/updateOrder';
        axios.post(updateUrl, order).catch(() => {
            swal({
                title: 'Error',
                text: 'Something went wrong while updating order, refresh the site and try again.',
                icon: 'error',
            });
        });
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <span>All game category blocks</span>
                <CreateButton
                    url={CASINO_GAME_CATEGORY_BLOCKS_CREATE}
                    permissions={[CRM_PERMISSION.GAME_CATEGORY_BLOCKS_CREATE]}
                    key="create"
                    buttonText="Create a new category block"
                />
            </div>
            <div className="card-body">
                <Loader
                    loading={isLoading}
                    content={() => (
                        <TableDraggable columns={columns} data={gameCategoryBlocks} onDropCallback={onDropCallback} />
                    )}
                />
            </div>
        </div>
    );
}

export default GameCategoryBlockList;
